/**
 * @file HSGraduatesToEmployment.js
 * @author Jake Stark
 * @desc HSGraduatesToEmployment report plugin

*/

/**
 * @module HSGraduatesToEmployment 
 * @desc HSGraduatesToEmployment report plugin
 */

define('plugins/HSGraduatesToEmployment',["underscore",
        "cardboard/models", "cardboard/collections", "cardboard/util", "models",
        "text!plugins/templates/HSGraduatesToEmployment_graduatesWorking_table.html!strip", 
        "text!plugins/templates/HSGraduatesToEmployment_hoursWages_head.html!strip", 
        "text!plugins/templates/HSGraduatesToEmployment_hoursWages_table.html!strip", 
        "text!plugins/templates/HSGraduatesToEmployment_industry_table.html!strip",
        "cardboard/pluginPieces"],
       function (_,
                  CardboardModels, CardboardCollections, Util, SLEDSModels, graduatesWorkingTemplate, 
                  hourWagesHeadTemplate, hourWagesTemplate, industryTemplate, PluginPieces) {

    console.log("MODULE: HSGraduatesToEmployment");
/*    function setFilterBoxWidth() {
    		$('.ui-checkbox').css('width', '35%');
	}
       setTimeout(setFilterBoxWidth, 3000);*/

    var exports = {

        // options for the demo cats config. since this is a multi-select
        // report, we have to use a different view object, and tell it not to
        // show grades as categories.
        options: {
            orgDetailPane: false,
            noMapSearch: true,
            definitions: true,
            forcedSummaryFilters: ["hsGradEmploymentCOHORTID"]
        },

        // each of these is the configuration that gets passed to a
        // DataBoxPaneView.
        panes: [
            {
                title: "Graduates Working",
                //titlePath: "collegeEnrollment.contents.0",
                explanationText: "<p>This report shows the number and percent of graduates who enrolled in college in the fall after graduation and those who did not attend college, but instead were found working in Minnesota. Graduates could be enrolled in college in Minnesota or in another state. Employed graduates are those found working in Minnesota one full-year after high school graduation. Graduates not found to be enrolled or working in Minnesota are included in the unknown count. These students may be working in another state, enlisted in military service, be self-employed or working in other organizations not subject to state reporting, or not engaged in the labor force. </p>",
                //explanationTextPath: "collegeEnrollment.contents.1",
                openByDefault: true,
                views: [
                    {
                        // SETUP
                        // one glob = one line series
                        // in each series, one row = one data point
                        type: "stackedColumn",
                        dataSourceName: "data",
                        dataPath: "graduatesWorking.data",

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsWithinRows",
                        dataDimensions: 2,

                        // DISPLAY
                        // xAxisLabelPath: "subjects.label",
                        unitString: "%",
                        showLegend: true,

                        // SERIES
                        series: [
                            {
                                seriesDisplayNamePath: "type",
                                dataPath: "orgs",
                                displayNamePath: "name",
                                valuePath: "percent"
                            }
                        ],
                       errorConditions: [
                            {
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }
                        ]
                    },
                    {
                        type: "template",
                        template: graduatesWorkingTemplate,
                        dataSourceName: "data"
                    }
                ]
            },
            {
                title: "Hours and Wages",
                explanationText: "<p>This report shows the distribution of hours worked and hourly wages represented by the average over the four quarters following high school graduation. Employment and wages are reported quarterly by employers who participate in the Unemployment Insurance Program in Minnesota. Full-time employment is often defined as working 35 hours or more per week and some employers (depending on size) are required to offer health insurance to employees working 30 hours or more per week.  </p> ",
                openByDefault: false,
                views: [
                        {
                        type: "template",
                        template: hourWagesHeadTemplate,
                        dataSourceName: "data"
                    },
                    {
                        // SETUP
                        type: "pie",
                        dataSourceName: "data",
                        dataSetPath: "hoursAndWages",
                        //dataPath: "dataSets.raceAndEthnicity.data", 
                        // all paths in the
                        // chartable series are
                        // relative to this blob

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsWithinRows",

                        // since in this case there's only one dimension, due to
                        // there being only one series to plot, it looks like
                        // this:
                        //	 +---------+
                        //	 | X X X X |
                        //	 +---------+
                        convertDataHashToArray: true,
                        dataDimensions: 1,
                        title: "",

                        // DISPLAY
                        unitString: "%",
                        unitDec: 0,

                        showLegend: true,
                        dataLabels: false,

                        // SERIES (only one series, this is a simple graph)
                        series: [{
                            valuePath: "percent",
                            displayNamePath: "type",
                            longDisplayNamePath: "type",
                        }],
                        errorConditions: [
                                {
                                    valuePath: "data.meta.dataNotAvailableMessage",
                                    isNot: "",
                                    error: {
                                        type: "NoData",
                                        messagePath: "data.meta.dataNotAvailableMessage"
                                    }
                                }
                            ]

                    },
                    {
                        type: "template",
                        template: hourWagesTemplate,
                        dataSourceName: "data"
                    }
                ]
            },
            {
                title: "Industry",
                explanationText: "<p>This report shows the number and percent of graduates who find employment in Minnesota by 11 industry categories along with the average hourly wage. Industries presented follow the North American Industrial Classification System (NAICS). Average hourly wages presented represent the industry sector in which an individual had worked the most hours.</p>",
                openByDefault: false,
                views: [ 
                  /*  {
                        // SETUP
                        // one glob = one line series
                        // in each series, one row = one data point
                        type: "stackedColumn",
                        dataSourceName: "data",
                        dataPath: "industry.data",

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsWithinRows",
                        dataDimensions: 2,

                        // DISPLAY
                        unitString: "%",
                        showLegend: true,

                        // SERIES
                        series: [
                            {
                                seriesDisplayNamePath: "type",
                                dataPath: "orgs",
                                displayNamePath: "name",
                                valuePath: "percent", 
                            },
                           
                        ],
                         errorConditions: [
                            {
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Sorry, we don't have any data for your selected College and Year."
                                }
                            }
                        ]
                    },*/
                    {
                        type: "template",
                        template: industryTemplate,
                        dataSourceName: "data",
                        errorConditions: [
                                {
                                    valuePath: "data.data.industry.meta.dataNotAvailableMessage",
                                    isNot: "",
                                    error: {
                                        type: "NoData",
                                        messagePath: "data.data.industry.meta.dataNotAvailableMessage"
                                    }
                                }
                            ]
                    }
                ]
            },
            
            {
                title: "More Information",
                visibleByDefault: true,
                openByDefault: false,
                views: [
                    {
                        type: "template",
                        template: "<p><a href='/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_hsgrademployment.fex&COHORTID=2020&orgId=999999000&groupType=state&outputFormat=xlsx' data-role='button' class='ui-link ui-btn ui-shadow ui-corner-all' role='button'>Download All Data</a></p><p>These reports show information about MN public graduates and their choice to enroll in college or work. Employed graduates are those found working in Minnesota one full-year after high school graduation. Graduates not found to be enrolled or working in Minnesota are included in the unknown count. These students may be working in another state, enlisted in military service, be self-employed or working in other organizations not subject to state reporting, or not engaged in the labor force.</p><p><a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031882&RevisionSelectionMethod=latestReleased&Rendition=primary'>Download web report data</a> for all high schools and years. Please note this file does not include subgroup statistics. For more information, <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031756&RevisionSelectionMethod=latestReleased&Rendition=primary'>read the help document</a>.</p>"
                    }
                ]
            }             /* {
                title: "More Information",
                visibleByDefault: true,
                openByDefault: false,
                views: [
                    {
                        type: "template",
                        template: "<p><a href='' data-role='button' class='ui-link ui-btn ui-shadow ui-corner-all' role='button'>Download All Data</a></p><p>In these reports, Minnesota public high school graduate data includes student records with a Status End code \"8\" or \"9\". These data are not the same student cohorts used by MDE to calculate the high school graduation rate.</p> <p>For more information on MCA and ACT results of Minnesota public high school graduates, please visit the  <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=059077&RevisionSelectionMethod=latestReleased&Rendition=primary'>Data Interpretation Guide</a> and the <a href='http://www.ohe.state.mn.us/mPg.cfm?pageID=740' target='_blank'>Office of Higher Education's Student Enrollment Data</a>.</p><p>These reports display graduates according to their last reported year of high school graduation.</p>"
                    }
                ]
            }*/

        ],

        filterSources: {

            orgs: {
                //	 RCModels.RCOrgList,
                modelType: SLEDSModels.SLEDSOrgList,
                url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_hsgrad_orgid_noschools.fex",
                //url: "/data/mocks/hsGradToEmp.json",
                noViewParams: true,
                enabled: true
            },
            filters: {
                modelType: CardboardModels.FilterData,
                url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_ecodevregion.fex",
                enabled: true
            },
            filters2: {
                url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_hsgrademploymentcohortid.fex",
                enabled: true,
                modelType: CardboardModels.FilterData
            },
            demographicCategories: {
                modelType: CardboardCollections.DemoCatProducer,
                url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_hsgrademployment_buttons.fex",
                enabled: true,
                noViewParams: true
            }
        },
        dataSources: {
            data: {
                modelType: CardboardModels.DocumentModel,
                // url: "/data/mocks/preGradData.json",
                // url: "/data/mocks/preGradData_statewide.json",
                url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_hsgrademployment.fex",
                // yearPath: "dataYear",
                defaultParams: {
                    orgId: 999999000,
                    hsGradEmploymentCOHORTID: 2020
                },
                paramMappings: {
                   COHORTID: "hsGradEmploymentCOHORTID",
                    orgName: null // skip this
                },
               /* postProcessor: function (data) {
                    // all we need to do is prettify all the org names!

                    var blobs = [
                        data.collegeEnrollment.slices,
                        data.enrollmentOptions.slices,
                        data.firstYearCredits.slices,
                        data.developmentalCredits.slices,
                        data.topTenInstitutions.institutions
                    ];

                    _(blobs).each(function (slices) {
                        _(slices).each(function (slice) {
                            _(slice.organizations).each(function (org) {
                                org.orgName = Util.Data.prettifyName(org.orgName);
                            });
                        });
                    });
                },*/
                enabled: true,
               /* errorConditions: [
                    {
                        valuePath: "errorMessage",
                        isNot: null,
                        error: {
                            type: "NoData",
                            message: "Sorry, we don't have any data for your selected school/district and year."
                        }
                    }
                ]*/
            }
            // http://edu-wfdevtest/ibi_apps/WFServlet?IBIF_ex=sledsws_getdata_contact_information.fex&HSGRAD_ORGID=999999000
        }
    };

    return exports;

});
